module.exports = __webpack_public_path__ + "img/rooms.498571ee.svg";